// Copyright ©️ 2026 eVolve MEP, LLC

type Listener = () => void;

/** Helper method for `useSyncExternalStore` to maintain a simple set of listeners. */
export const getBasicStoreListeners = () => {
  const listeners = new Set<Listener>();

  return {
    subscribe: (listener: Listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    notifyListeners: () => listeners.forEach((l) => l()),
  } as const;
};
